import { Action, createReducer, on } from '@ngrx/store'
import * as objectTreeActions from './actions'
import { ObjectTreeState } from './state'

export const initialObjectTreeState: ObjectTreeState = {
  itemsLoaded: false,
  tree: null,
  items: null,
  selectedItems: [],
  errors: null,
  subCatalogId: null
}

const objectTreeReducers = createReducer(
  initialObjectTreeState,
  on(objectTreeActions.SetTreeItems, (state, { items }) => ({ ...state, items: items.items, tree: items.tree, itemsLoaded: true })),
  on(objectTreeActions.ClearTreeItems, (state, { }) => ({ ...state, items: null, tree: null, itemsLoaded: false })),
  on(objectTreeActions.SetTreeItemsLoading, (state, { }) => ({ ...state, itemsLoaded: 'Loading' })),
  on(objectTreeActions.SetSelectedItems, (state, { items }) => {
    const subCatalogId = items?.find(i => i.item.catalogId)?.item.catalogId ?? null
    return { ...state, selectedItems: [...items], subCatalogId }
  }),
  on(objectTreeActions.SetTreeErrors, (state, { errors }) => ({ ...state, errors }))
)

export function reducers(state: ObjectTreeState | undefined, action: Action): ObjectTreeState {
  return objectTreeReducers(state, action)
}
